import React from 'react';

import type { IconProps } from './icon';
import type { BoxProps } from '@mui/material';
import type { IconName } from '@sbv-clients/ui-shared';
import { toLower, trim } from 'lodash';

import { Icon } from './icon';

type ShiftIconProps = Omit<IconProps, 'name'> & {
  name?: string | null;
  customSizes?: BoxProps['sx'];
};

const getShiftIconName = (name?: string | null): IconName => {
  const value = trim(toLower(name ?? ''));
  if ('day'.includes(value) || value.includes('day')) {
    return 'DaySVG';
  } else if ('evening'.includes(value) || value.includes('evening')) {
    return 'EveningSVG';
  } else if ('night'.includes(value) || value.includes('night')) {
    return 'NightSVG';
  }
  return 'DaySVG';
};

export const ShiftIcon: React.FC<ShiftIconProps> = ({
  name,
  customSizes,
  ...iconProps
}) => {
  const iconName = getShiftIconName(name);

  return <Icon name={iconName} customSizes={customSizes} {...iconProps} />;
};
